<template>
  <div>
    <el-row :gutter="32" style="margin-bottom: 32px;text-align: center;">
      <el-col :xs="12" :sm="6">
        <el-card shadow="hover">
          <p>访问总数</p>
          <h2>{{ totalViewCount }}</h2>
        </el-card>
      </el-col>
      <el-col :xs="12" :sm="6">
        <el-card shadow="hover">
          <p>文章总数</p>
          <h2>{{ totalArticle }}</h2>
        </el-card>
      </el-col>
      <el-col :xs="12" :sm="6">
        <el-card shadow="hover">
          <p>留言总数</p>
          <h2>{{ totalLeaveCount }}</h2>
        </el-card>
      </el-col>
      <el-col :xs="12" :sm="6">
        <el-card shadow="hover">
          <p>评论总数</p>
          <h2>{{ totalReplyCount }}</h2>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="32" style="margin-bottom: 32px;text-align: center;">
      <el-col :xs="12" :sm="6">
        <el-card shadow="hover">
          <p>今日注册数</p>
          <h2>{{ totalRegisterCount }}</h2>
        </el-card>
      </el-col>
      <el-col :xs="12" :sm="6">
        <el-card shadow="hover">
          <p>今日登录数</p>
          <h2>{{ totalLoginCountToday }}</h2>
        </el-card>
      </el-col>
      <el-col :xs="12" :sm="6">
        <el-card shadow="hover">
          <p>今日留言数</p>
          <h2>{{ totalLeaveCountToday }}</h2>
        </el-card>
      </el-col>
      <el-col :xs="12" :sm="6">
        <el-card shadow="hover">
          <p>今日评论数</p>
          <h2>{{ replyCountToday }}</h2>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="32">
      <el-col id="blog_list" :xs="24" :sm="18">
        <el-card class="blogList" shadow="hover">
          <div class="content" style="padding-right: 10px">
            <el-table
              :data="blogListData"
              :header-cell-style="{'text-align':'center','font-size':'15px'}"
              :cell-style="{'text-align':'center'}"
              style="width: 100%; ">
              <el-table-column
                prop="title"
                label="最新博客"
                width="600"
              >
              </el-table-column>
              <el-table-column
                prop="adminName"
                label="作者"
              >
              </el-table-column>
              <el-table-column
                prop="categoryName"
                label="类型">
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="6">
        <el-card class="comment" shadow="hover">
          <div class="distance">
            <el-tag style="font-size: 16px;height: 40px;line-height: 40px">最新留言</el-tag>

            <!--遍历-->
            <div v-for="item of comment" :key="item.id">
              <div style="margin-top: 20px;display: flex;flex-wrap:wrap;">
                <img :src="item.user[0].headPortrait" height="40" width="40"
                     style="border-radius: 50%;margin-left: 5px">
                <div style="font-size: 18px;display: flex;line-height: 40px;margin-left: 5px">{{
                    item.user[0].name
                  }}
                </div>
                <div style="font-size: 16px;display: flex;line-height: 40px;margin-left: 5px">{{
                    item.createTime
                  }}
                </div>
              </div>
              <div style="margin-top: 10px">{{ item.content }}</div>
              <hr>
            </div>

          </div>
        </el-card>
      </el-col>
    </el-row>

  </div>

</template>

<script>
import request from "../../utils/axiosUtils";
import base_url from "../../utils/Constants";

export default {
  name: "AdminHome",

  data() {
    return {
      totalViewCount: null,
      totalArticle: null,
      totalLeaveCount: null,
      totalReplyCount: null,
      replyCountToday: null,
      totalRegisterCount: null,
      totalLoginCountToday: null,
      totalLeaveCountToday: null,
      adminInfo: {},
      blogListData: [
        {
          title: null,
          adminName: null,
          categoryName: null,
        },
      ],
      comment: [
        {
          content: null,
          creatTime: null,
          user: [
            {
              id: null,
              headPortrait: null,
              name: null,
            },

          ],

        },

      ],
    }
  },
  methods: {
    //最新博客
    getNewBlog() {
      let that = this;
      request({
        url: '/blog/getBlog',
        method: 'get',
        params: {
          page: "1",
        }
      }).then(response => {
        // console.log(response.data.data);
        that.blogListData = response.data.data;
      })
    },
    //最近登录
    recentLogin(data) {
      let currentTime = new Date().getTime();
      let recentTime = new Date(
        data.substr(0, 4),
        parseInt(data.substr(5, 2)) - 1,
        data.substr(8, 2),
        data.substr(11, 2),
        data.substr(14, 2),
        data.substr(17, 2),
      ).getTime();
      let TimeDifference = currentTime - recentTime;
      let min = parseInt(TimeDifference / 1000 + "");
      let targetTime = null;
      if (min >= 60 * 60 * 24 * 30 * 12) {
        targetTime = parseInt(min / (60 * 60 * 24 * 30 * 12)) + "年前";
      } else if (min >= 60 * 60 * 24 * 30) {
        targetTime = parseInt(min / (60 * 60 * 24 * 30)) + "月前";
      } else if (min >= 60 * 60 * 24) {
        targetTime = parseInt(min / (60 * 60 * 24)) + "天前";
      } else if (min >= 60 * 60) {
        targetTime = parseInt(min / (60 * 60)) + "小时前";
      } else if (min >= 60) {
        targetTime = parseInt(min / 60) + "分前";
      } else {
        targetTime = min + "秒前";
      }
      return targetTime;

    },

    //是否大与 1W
    getTotalViewCount(count) {
      if (count == null) {
        return 0
      } else {

        let number;
        if (count >= 10000) {
          let sum = (count) / 10000;
          let realVal = parseFloat(sum).toFixed(1)
          number = realVal + "w";
          return number;
        } else {
          number = count;
          return number;
        }

      }
    },

    //最新留言
    getNewLeave() {
      let that = this;
      request({
        url: '/blog/getNewLeave',
        method: 'get',
        params: {
          adminInfo: that.adminInfo,
        }
      }).then(response => {
        if (response.data.data == null) {
        } else {
          response.data.data.forEach(value => {
            value.user[0].headPortrait = base_url + "/getImage/" + value.user[0].headPortrait
            value.createTime = that.recentLogin(value.createTime);
          })
          this.comment = response.data.data;
          // console.log(this.comment)
        }
      })
    },
    //总数据
    getAdminInfoCount() {
      let that = this;
      request({
        url: '/blog/getTotleViewCount',
        method: 'get',
        params: {
          adminInfo: that.adminInfo,
        }
      }).then(response => {
        // console.log(response.data.data);
        if (response.data.data == null) {
          // console.log("请求的数据为空")
        } else {
          //总浏览量
          that.totalViewCount = that.getTotalViewCount(response.data.data.viewCount);
          //文章总数
          that.totalArticle = that.getTotalViewCount(response.data.data.articleCount);
          //留言总数
          that.totalLeaveCount = that.getTotalViewCount(response.data.data.leaveMsgCount);
          //回复总数
          that.totalReplyCount = that.getTotalViewCount(response.data.data.replyCount);
          //今日评论数
          that.replyCountToday = that.getTotalViewCount(response.data.data.replyCountToday);
          //今日注册数
          that.totalRegisterCount = that.getTotalViewCount(response.data.data.numberRegistToday);
          //今天用户登录数
          that.totalLoginCountToday = that.getTotalViewCount(response.data.data.loginCountToday);
          //今天留言数
          that.totalLeaveCountToday = that.getTotalViewCount(response.data.data.leaveMsgCountToday);
        }
      })

    }
  },
  mounted() {
    let data = JSON.parse(window.sessionStorage.getItem("adminInfo"));
    this.adminInfo = data;
    this.getAdminInfoCount();
    this.getNewLeave();
    this.getNewBlog();
  }
}
</script>


<style>

</style>

<style scoped>
.el-card:hover {
  cursor: pointer;
}

.el-card /deep/ .el-card__body {
  padding: 0;
}


.blogList {
  height: max-content;
  width: 100%;
  border-radius: 5px;
  margin-top: 10px;
}

.blogList :first-child {
  padding: 5px;
  font-size: 18px;
}

.comment {
  margin-top: 10px;
  padding: 5px;
}

.comment .distance {
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/AdminHome.vue